// Descriptive SDK identity for the `x-highnote-sdk` adoption-telemetry header
// (`<name>/<version>`). Lives in @highnoteplatform/types because that is the
// only package bundled into every public SDK's parcel build (see
// secureChannel.ts) — the one bundle-safe shared home.
//
// HOW TO INSTRUMENT A NEW SDK
// 1. In the SDK package, import its own package.json name + version:
//        import { name, version } from "../package.json";
// 2. Build the identity so `name` can't drift from the published package name:
//        const SDK = sdkIdentityFromPackage({ name, version });
// 3. Page-context SDK: pass SDK as the 3rd arg to `highnoteClient(...)`, behind a
//    small `xxxClient` factory (see documentUploadClient / riskApplicationClient).
//    Iframe SDK: reuse SDK.name for BOTH the CDN path segment and the
//    secure-channel handshake `sdkName` (see card-viewer/secure-inputs
//    config.ts + handshake.ts) so telemetry and CDN can't desync.
export interface SdkIdentity {
  name: string;
  version: string;
}

const SCOPE_PREFIX = /^@highnoteplatform\//;

// Strips the npm scope so the telemetry name matches the CDN path segment
// (`card-viewer`, not `@highnoteplatform/card-viewer`).
export const sdkIdentityFromPackage = (pkg: {
  name: string;
  version: string;
}): SdkIdentity => ({
  name: pkg.name.replace(SCOPE_PREFIX, ""),
  version: pkg.version,
});
